import { render, staticRenderFns } from "./AddEducationalQualificationRecord.vue?vue&type=template&id=e62e55c2"
import script from "./AddEducationalQualificationRecord.vue?vue&type=script&lang=ts"
export * from "./AddEducationalQualificationRecord.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports